import { TextField } from 'mui-rff';
import React, { useMemo } from 'react';
import { useField } from 'react-final-form';

import SenderSelectField from '@dashboard/components/form-fields/SenderSelectField';
import { ButtonBase, Stack } from '@mui/material';
import TooltipUnderline from '@wp-react/components/TooltipUnderline';

import { markdownSenderTypeParser } from './valueParsers';

type Props = {
  name: string;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FormHelperTextProps = { component: 'div' } as any;

export default function FromTemplateInput({ name }: Props) {
  const { onChange, value } = useField(`${name}.sendMarkdownEmailMessage.senderType`).input;

  const currentValue = useMemo(() => markdownSenderTypeParser.parse(value), [value]);

  switch (currentValue) {
    case 'TEMPLATE':
      return (
        <TextField
          name={`${name}.sendMarkdownEmailMessage.fromTemplate`}
          label="From"
          margin="normal"
          placeholder="{{sender.displayName}} <{{sender.emailAddress}}>"
          size="small"
          FormHelperTextProps={FormHelperTextProps}
          helperText={
            <Stack justifyContent="flex-end" direction="row" spacing={1}>
              <TooltipUnderline title="Select from your list of approved senders on this workspace.">
                <ButtonBase sx={{ fontSize: 12 }} onClick={() => onChange('VERIFIED_EMAIL_ADDRESS')}>
                  Select from an approved sender
                </ButtonBase>
              </TooltipUnderline>
            </Stack>
          }
        />
      );
    case 'VERIFIED_EMAIL_ADDRESS':
      return (
        <SenderSelectField
          name={`${name}.sendMarkdownEmailMessage.senderVerifiedEmailAddressId`}
          label="From"
          FormHelperTextProps={FormHelperTextProps}
          helperText={
            <Stack justifyContent="flex-end" direction="row" spacing={1}>
              <TooltipUnderline title="Reference variables to set this sender's email address.">
                <ButtonBase sx={{ fontSize: 12 }} onClick={() => onChange('TEMPLATE')}>
                  Use Liquid templating
                </ButtonBase>
              </TooltipUnderline>
            </Stack>
          }
        />
      );
  }
}
